import { watchAccount } from '@wagmi/core';
import { useEffect } from 'react';

import { config } from '~/config/wagmi';
import type { OriginName } from '~/interfaces/common';
import { getLocalStorageItem } from '~/utils/local-storage';

let hasTriggered = false;

interface AttestationChallengeProps {
  handleAttestationChallenge: (
    originName: OriginName,
    address: string,
  ) => Promise<void>;
}

export function AttestationChallenge({
  handleAttestationChallenge,
}: AttestationChallengeProps) {
  useEffect(() => {
    const unwatch = watchAccount(config, {
      async onChange(data) {
        const address = data.address;
        if (address && data.isConnected && !hasTriggered) {
          hasTriggered = true;
          const originName = getLocalStorageItem<OriginName>('originName');
          if (address && originName) {
            await handleAttestationChallenge(originName, address);
          }
        }
      },
    });

    return () => {
      unwatch();
    };
  }, []);

  return null;
}
